import {
  analyticsCategories,
  logGTMTrackingEvent
} from "seneca-common/utils/senecaAnalytics";

export const analyticsLogWinMemory = (memory: any, state: any) => {
  logGTMTrackingEvent(
    {
      category: analyticsCategories.MEMORY,
      event: "seneca/memories/WIN_MEMORY",
      payload: { ...memory }
    },
    state
  );
};
